import { CheckEvaluationEligibilityInput, CheckEvaluationEligibilityResponse } from '@/models/gen/graphql';

import { CheckEvaluationEligibilityDocument } from '@/api/queries';
import graphApi from '@/api';

const [_, runCheckEvaluationEligibility] = graphApi(CheckEvaluationEligibilityDocument);

export const checkEvaluationEligibility = async (subjectUserId: string): Promise<CheckEvaluationEligibilityResponse> => {
  const input: CheckEvaluationEligibilityInput = { subjectUserId };
  const res = await runCheckEvaluationEligibility({ input });

  return res?.checkEvaluationEligibility;
};
